import { MDBCardBody, MDBListGroup } from 'mdb-react-ui-kit'
import styled from 'styled-components'

export const ReelsList = styled(MDBListGroup)(() => `
    .list-group-item {
        border: none;
        padding-left: 0;
        padding-right: 0;
        display: flex;
        gap: 8px;

        > span {
            &.no-reel {
                opacity: .5;
            }

            > .svg-inline--fa {
                width: 14px;
                height: 14px;
            }
        }
    }
`)

export const ReelsFormBody = styled(MDBCardBody)(({ theme }) => `
    .soundtrack__row {
        flex-grow: 1;
    }

    .row-info__container {
        .form-outline {
            max-width: calc(100% - 24px);
        }
    }

    @media (min-width: ${theme.minDesktopWidth}) {
        .row-info__container.has-soundtrack {
            .form-outline {
                max-width: 100%;
            }
        }
    }

    .align-start {
        align-items: flex-start;
    }
`)